<template>
  <div class="review-sheet">
    <!-- 标题 -->
    <div class="sheet-title">
      <span>申报条件审查</span>
      <el-button type="primary" size="small" @click="onSave" :loading="saving" :disabled="readOnly || !canSubmit" v-if="is_view == 0">保存</el-button>
    </div>

    <!-- 表头 -->
    <div class="sheet-head">
      <div class="h-col item">审核类目</div>
      <div class="h-col standard standarddesc">审核标准</div>
      <div class="h-col judge">结论</div>
    </div>

    <!-- =========== 申报条件审查 =========== -->
    <div class="sheet-body">
      <!-- 1. 内容与名称是否一致（仅是否） -->
      <!-- 1. 内容与名称是否一致（仅是否） -->
      <div class="s-row">
        <div class="s-col item" style="bottom: -20px;position: relative;">工法名称</div>
        <div class="s-col standard standarddesc">内容与名称是否一致</div>
        <div class="s-col judge">
          <el-radio-group v-model="form.name_match.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 2. 是否与过去批准工法相同（仅是否） -->
      <div class="s-row"  style="border-top:0px">
        <div class="s-col item"></div>
        <div class="s-col standard standarddesc" style="border-top:1px solid #ebeef5;">是否与过去批准工法相同</div>
        <div class="s-col judge" style="border-top:1px solid #ebeef5;">
          <el-radio-group v-model="form.history_match.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 2. 是否与过去批准工法相同（仅是否） -->
     
      <!-- 3. 企业级工法（两列结构，每条子项 + 黄底意见） -->
      <template>
        <div class="s-row s-row--merge" :key="'ent-row-'+i">
          <div
            class="s-col item titlecenter"
          >
            企业级工法审查
          </div>

          <div class="s-col standard s-merge">
              <div v-for="(line, i) in baseEnterprise.lines" :class=" i == 1 ? 'sbaseline' : ''">
                 <div class="sdesc" :style="i == 1 ? 'padding-top:10px': ''"> {{ line.standard }}</div>
                 <div class="s-comment" :key="'ent-c-'+i" >
                      <div class="c-label">审核意见：</div>
                      <el-input
                        type="textarea"
                        :rows="2"
                        class="c-input"
                        placeholder="请输入评审意见"
                        v-model="form[line.key].comment"
                        :disabled="readOnly"
                        maxlength="400"
                        show-word-limit
                      />
                    </div>
              </div>
              
             
        </div>
         
        </div>
        
      </template>

      <!-- 4. 工法主要完成单位及完成人审查（两列 + 黄底意见） -->
      <div class="s-row s-row--merge">
        <div class="s-col item titlecenter">工法主要完成单位及完成人审查</div>
        <div class="s-col standard s-merge">
            <div class="sdesc">必须提供企业级工法相关文件，主要完成人在公布文件之列。</div>
              <div class="s-comment">
                <div class="c-label">审核意见：</div>
                <el-input
                  type="textarea"
                  :rows="2"
                  class="c-input"
                  placeholder="请输入评审意见"
                  v-model="form.main_units_members.comment"
                  :disabled="readOnly"
                  maxlength="400"
                  show-word-limit
                />
              </div>
        </div>
      </div>
      

      <!-- 5. 申报工法的工程应用实例审查（两列 + 黄底意见） -->
      <div class="s-row s-row--merge">
        <div class="s-col item titlecenter">申报工法的工程应用实例审查</div>
        <div class="s-col standard s-merge">
            <div class="sdesc">是否有工法应用工程的建设单位或监理单位出具的应用证明，省外企业申报的工法，工程应用实例中是否有 1 例在贵州省境内</div>
          <div class="s-comment">
            <div class="c-label">审核结论：</div>
            <el-radio-group v-model="form.outside_province.pass" :disabled="readOnly">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      

      <!-- 6. 关键技术论证、鉴定证书审查，效益证明审查（仅是否） -->
      <div class="s-row">
        <div class="s-col item"><spna style="bottom: -40px;position: relative;display:inline-block;">关键技术论证、鉴定证书审查，效益证明审查</spna></div>
        <div class="s-col standard standarddesc">鉴定（评估）或论证专家组是否满足有关要求</div>
        <div class="s-col judge">
          <el-radio-group v-model="form.key_certificates_member.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 2. 是否与过去批准工法相同（仅是否） -->
      <div class="s-row"  style="border-top:0px">
        <div class="s-col item"></div>
        <div class="s-col standard standarddesc" style="border-top:1px solid #ebeef5;">证书内容是否真实有效</div>
        <div class="s-col judge" style="border-top:1px solid #ebeef5;">
          <el-radio-group v-model="form.key_certificates_cert.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="s-row"  style="border-top:0px">
        <div class="s-col item"></div>
        <div class="s-col standard standarddesc" style="border-top:1px solid #ebeef5;">效益证明是否有效真实</div>
        <div class="s-col judge" style="border-top:1px solid #ebeef5;">
          <el-radio-group v-model="form.key_certificates_xiaoyi.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
     
     
      <!--<div class="s-row">-->
      <!--  <div class="s-col item"></div>-->
      <!--  <div class="s-col standard standarddesc">-->
      <!--      ；； -->
      <!--  </div>-->
      <!--   <div class="s-col judge">-->
      <!--    <el-radio-group v-model="form.key_certificates.pass" :disabled="readOnly">-->
      <!--      <el-radio :label="true">是</el-radio>-->
      <!--      <el-radio :label="false">否</el-radio>-->
      <!--    </el-radio-group>-->
      <!--  </div>-->
      <!--</div>-->
    </div>

    <!-- =========== 工法文本审查（都是仅是否） =========== -->
    <div class="part-title">工法文本审查</div>
    <div class="sheet-body">
      <div class="s-row" v-for="(row, i) in textOnlyJudge" :key="'text-'+i">
        <div class="s-col item ">{{ row.title }}</div>
        <div class="s-col standard standarddesc">{{ row.standard }}</div>
        <div class="s-col judge">
          <el-radio-group v-model="form[row.key].pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>

    <!-- =========== 编写内容审查（全部两列结构 + 黄底意见） =========== -->
    <div class="part-title">编写内容审查</div>
    <div class="sheet-body" style="border-top:">
      <template v-for="(row, i) in contentRows">
        <div class="s-row s-row--merge" :key="'con-'+i">
          <div class="s-col item titlecenter" v-if="row.key != 'process_keypoints'">{{ row.title }}</div>
          <div class="s-col standard s-merge"  v-if="row.key != 'process_keypoints'">
              <div class="sdesc">{{ row.standard }}</div>
              <div class="s-comment" :key="'con-c-'+i">
              <div class="c-label">审核意见：</div>
              <el-input
                type="textarea"
                :rows="2"
                class="c-input"
                placeholder="请输入评审意见"
                v-model="form[row.key].comment"
                :disabled="readOnly"
                maxlength="400"
                show-word-limit
              />
            </div>
            
          </div>
          
          <div class="s-col item " v-if="row.key == 'process_keypoints'">{{ row.title }}</div>
            <div class="s-col standard standarddesc" v-if="row.key == 'process_keypoints'">{{ row.standard }}</div>
            <div class="s-col judge" v-if="row.key == 'process_keypoints'">
              <el-radio-group v-model="form[row.key].pass" :disabled="readOnly">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </div>
            
            
        </div>
        
      </template>
    </div>

    <!-- =========== 审查人意见 =========== -->
    <div class="part-title">审查人意见</div>
    <div class="sheet-body">
      <!-- 1. 只意见（两列） -->
      <div class="s-row s-row--merge">
        <div class="s-col item">1、工法关键技术水平？</div>
        <div class="s-col standard s-merge"></div>
      </div>
      <div class="s-comment">
        <div class="c-label">审核意见：</div>
        <el-input
          type="textarea"
          :rows="2"
          class="c-input"
          placeholder="请输入评审意见"
          v-model="form.key_tech_level.comment"
          :disabled="readOnly"
          maxlength="400"
          show-word-limit
        />
      </div>

      <!-- 2. 仅是否 -->
      <div class="s-row">
        <div class="s-col item " style="width: 500px; border-right: 0px;text-align:left;">2、是否适用于省内工程？</div>
                <div class="s-col standard" style="padding-right:0px"></div>
        <div class="s-col judge">
          <el-radio-group v-model="form.suitable_in_province.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 3. 仅是否 + 否时填写理由 -->
      <div class="s-row">
        <div class="s-col item "  style="width: 500px; border-right: 0px;text-align:left;">3、是否同意推荐为省级工法？</div>
        <div class="s-col standard " style="padding-right:0px"></div>
        <div class="s-col judge">
          <el-radio-group v-model="form.recommend_provincial.pass" :disabled="readOnly">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="reject-reason" v-if="form.recommend_provincial.pass===false">
        <div class="r-label">不通过的充分理由：</div>
        <el-input
          type="textarea"
          :rows="2"
          class="r-input"
          placeholder="请填写不同意的充分理由"
          v-model="form.rejection_reason"
          :disabled="readOnly"
          maxlength="400"
          show-word-limit
        />
      </div>
    </div>
  </div>
</template>

<script>
import { saveopinion } from '@/utils/api'; // 按路径调整

function normalizeRecommendDecision(value) {
  if (value === true || value === 1 || value === '1' || value === 'true' || value === '是' || value === 'yes') {
    return true
  }
  if (value === false || value === 0 || value === '0' || value === 'false' || value === '否' || value === 'no') {
    return false
  }
  return null
}

export default {
  name: 'ReviewOpinionSheet',
  props: {
    initial: { type: Object, default: () => ({}) },
    award_log_id: { type: [String, Number], required: true },
    is_view: { type: [String, Number], default: 0 } // 1=只读
  },
  data() {
    // 企业级工法：子项（两列 + 黄底意见）
    const baseEnterprise = {
      lines: [
        { key: 'enterprise_approval_origin', standard: '审查批准部门原件' },
        { key: 'enterprise_dispute', standard: '审查无争议证明' }
      ]
    };

    // 工法文本审查：仅是否
    const textOnlyJudge = [
      { key: 'name_content_match', title: '工法名称与内容审查', standard: '名称与内容是否贴切，能否直观反映工法名称' },
      { key: 'hierarchy_order', title: '工法的叙述层次排列', standard: '是否按章、节、条款、项、层次排列' },
      { key: 'table_figures', title: '工法中表格、插图审查', standard: '表格、图应有名称，图表应有文字描述及编号' }
    ];

    // 编写内容审查：全部两列 + 意见
    const contentRows = [
      { key: 'features', title: '工法特点审查', standard: '使用功能或施工方法上是否具备先进性、科学性、适用性、效益性、成熟型与应用性的特点' },
      { key: 'content_items', title: '工法内容审查', standard: '材料与设备、质量安全、经济效益' },
      { key: 'scope', title: '适用范围审查', standard: '采用该工法的工程对象或工程部位' },
      { key: 'environment', title: '环保节能审查', standard: '环保节能措施及效果' },
      { key: 'cases', title: '应用实例', standard: '工程名称、合同、鉴定或提供成熟可靠性证书' },
      { key: 'principle', title: '工艺原理审查', standard: '关键技术基本原理是什么？特点是什么？其安全性可靠性？' },
      { key: 'process_keypoints', title: '关键技术证明（专利号、专利权人）', standard: '是否有关键技术证明' },
      { key: 'process_req', title: '工艺流程及操作要求审查', standard: '讲清基本工艺过程、工序衔接，工艺水平达到什么程度' },
    ];

    // 初始化所有字段
    const form = {
      // 单选类
      name_match: { pass: null, comment: '' },
      history_match: { pass: null, comment: '' },
      key_certificates_xiaoyi: { pass: null, comment: '' },
      key_certificates_cert: { pass: null, comment: '' },
      key_certificates_member: { pass: null, comment: '' },
      name_content_match: { pass: null, comment: '' },
      hierarchy_order: { pass: null, comment: '' },
      table_figures: { pass: null, comment: '' },

      suitable_in_province: { pass: null, comment: '' },
      recommend_provincial: { pass: null, comment: '' },

      // 两列 + 意见类
      enterprise_approval_origin: { pass: null, comment: '' },
      enterprise_dispute: { pass: null, comment: '' },
      main_units_members: { pass: null, comment: '' },
      outside_province: { pass: null, comment: '' },

      features: { pass: null, comment: '' },
      content_items: { pass: null, comment: '' },
      scope: { pass: null, comment: '' },
      environment: { pass: null, comment: '' },
      cases: { pass: null, comment: '' },
      principle: { pass: null, comment: '' },
      process_req: { pass: null, comment: '' },
      process_keypoints: { pass: null, comment: '' },

      // 审查人意见
      key_tech_level: { pass: null, comment: '' },

      // 推荐否时的理由
      rejection_reason: ''
    };

    // 旧数据回填（字符串 -> comment；新结构 {pass,comment} 原样回填）
    Object.keys(this.initial || {}).forEach(k => {
      if (form[k] != null) {
        const v = this.initial[k];
        if (v && typeof v === 'object' && ('pass' in v || 'comment' in v)) {
          form[k].pass = v.pass != null ? v.pass : form[k].pass;
          form[k].comment = v.comment != null ? String(v.comment) : form[k].comment;
        } else {
          if (typeof form[k] === 'object' && 'comment' in form[k]) {
            form[k].comment = String(v == null ? '' : v);
          } else if (k === 'rejection_reason') {
            form.rejection_reason = String(v || '');
          }
        }
      } else if (k === 'rejection_reason') {
        form.rejection_reason = String(this.initial[k] || '');
      }
    });
    
    // ✅ 需要“选择 是/否”的必填项
    const requirePassKeys = [
      'name_match',
      'history_match',
      'key_certificates_xiaoyi',
      'key_certificates_cert',
      'key_certificates_member',
      'name_content_match',
      'hierarchy_order',
      'table_figures',
      'outside_province',
      'suitable_in_province',
      'recommend_provincial',
       'process_keypoints',

    ];

    // ✅ 需要“填写意见（黄底输入框）”的必填项
    const requireCommentKeys = [
      // 企业级工法 2 条
      'enterprise_approval_origin',
      'enterprise_dispute',

      // 工法主要完成单位
      'main_units_members',

      // 编写内容审查 全部意见项
      'features',
      'content_items',
      'scope',
      'environment',
      'cases',
      'principle',
      'process_req',

      // 审查人意见：工法关键技术水平（只有意见）
      'key_tech_level',
    ];

    // ✅ 显示友好名称（用于错误提示）
    const fieldLabels = {
      name_match: '工法名称：内容与名称是否一致',
      history_match: '工法名称：是否与过去批准工法相同',
      key_certificates: '关键技术专家论证审查及效益证明审查',

      name_content_match: '工法文本审查：工法名称与内容审查',
      hierarchy_order: '工法文本审查：工法的叙述层次排列',
      table_figures: '工法文本审查：工法中表格、插图审查',

      enterprise_approval_origin: '企业级工法：审查批准部门原件（意见）',
      enterprise_dispute: '企业级工法：审查无争议证明（意见）',
      main_units_members: '工法主要完成单位及完成人审查（意见）',
      outside_province: '申报工法的工程应用实例审查',

      features: '编写内容审查：工法特点审查（意见）',
      content_items: '编写内容审查：工法内容审查（意见）',
      scope: '编写内容审查：适用范围审查（意见）',
      environment: '编写内容审查：环保节能审查（意见）',
      cases: '编写内容审查：应用实例（意见）',
      principle: '编写内容审查：工艺原理审查（意见）',
      process_req: '编写内容审查：工艺流程及操作要求审查（意见）',
      process_keypoints: '编写内容审查：关键技术证明（意见）',

      suitable_in_province: '是否适用于省内工程',
      recommend_provincial: '是否同意推荐为省级工法',
      key_tech_level: '审查人意见：工法关键技术水平（意见）',
      rejection_reason: '不通过的充分理由',
    };
    
    return {
      form,
      saving: false,
      baseEnterprise,
      textOnlyJudge,
      contentRows,
      rowHeight: 92,
      requirePassKeys,
      requireCommentKeys,
      fieldLabels,
      isFinished:0
    };
  },
  computed: {
    readOnly() { return String(this.is_view) === '1'; },
    // ✅ 是否可以提交：全部满足才为 true
    canSubmit() {
      // 1) 所有”是/否”项必须已选择
      const passOk = this.requirePassKeys.every(k => this.form[k] && this.form[k].pass !== null);
      // 2) 不推荐时必须填写不推荐理由；意见框为选填，不纳入必填校验
      const needReason = normalizeRecommendDecision(this.form.recommend_provincial?.pass) === false;
      const reasonOk = !needReason || String(this.form.rejection_reason || '').trim().length > 0;
      this.isFinished = (passOk && reasonOk) ? 1 : 0;
      return true;
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit('opinionsave', this.getPayload());
      }
    }
  },
  methods: {
    validate() {
      const missing = []
      // 校验所有"是/否"单选项
      this.requirePassKeys.forEach(k => {
        if (!this.form[k] || this.form[k].pass === null) {
          missing.push(this.fieldLabels[k] || k)
        }
      })
      // 不推荐时校验不推荐理由；意见框为选填
      const needReason = normalizeRecommendDecision(this.form.recommend_provincial?.pass) === false
      if (needReason && !String(this.form.rejection_reason || '').trim()) {
        missing.push(this.fieldLabels['rejection_reason'] || '不推荐理由')
      }
      return missing
    },
    getPayload() {
      const payload = { rejection_reason: (this.form.rejection_reason || '').trim() };
      Object.keys(this.form).forEach(k => {
        if (k === 'rejection_reason') return;
        payload[k] = {
          pass: this.form[k].pass,
          comment: (this.form[k].comment || '').trim(),
        };
      });
      payload.isFinished = this.isFinished;
      return payload;
    },
    async onSave() {
      if (normalizeRecommendDecision(this.form.recommend_provincial.pass) === false &&
          !String(this.form.rejection_reason || '').trim()) {
        this.$message.warning(`请填写「${this.fieldLabels.rejection_reason}」`);
        return;
      }
      const payload = this.getPayload();

      this.saving = true;
      try {
        await saveopinion(this.award_log_id, payload);
        this.$message.success('保存成功');
        this.$emit('opinionsave', payload);
      } catch (e) {
        this.$message.error('保存失败');
      } finally {
        this.saving = false;
      }
      
    //   const payload = { rejection_reason: (this.form.rejection_reason || '').trim() };
    //   Object.keys(this.form).forEach(k => {
    //     if (k === 'rejection_reason') return;
    //     payload[k] = {
    //       pass: this.form[k].pass,
    //       comment: (this.form[k].comment || '').trim()
    //     };
    //   });
    //   this.saving = true;
    //   try {
    //     await saveopinion(this.award_log_id, payload);
    //     this.$message.success('保存成功');
    //     this.$emit('save', payload);
    //   } catch (e) {
    //     this.$message.error('保存失败');
    //   } finally {
    //     this.saving = false;
    //   }
    }
  }
};
</script>

<style scoped>
.review-sheet { background: #fff; }

.sheet-title{
  display:flex; align-items:center; justify-content:space-between;
  font-weight:600; padding:10px 8px 6px;
}

/* 表头 */
.sheet-head{
  display:grid; grid-template-columns:200px 1fr 200px;
  border:1px solid #ebeef5; border-bottom:0;
  background:#fafafa; color:#606266; font-weight:600;
}
.h-col{ padding:10px 12px; border-right:1px solid #ebeef5; }
.h-col:last-child{ border-right:0; }

/* 小节标题 */
.part-title{
  font-weight:600; padding:12px 8px 6px; border-top:1px solid #eee; background:#fff;
  text-align: left;
}

/* 表体行 */
.sheet-body{ border:1px solid #ebeef5; border-top:0; }
.s-row{
  display:grid; grid-template-columns:200px 1fr 200px;
  border-top:1px solid #ebeef5;
}
/*.s-row:first-child{ border-top:0; }*/
.s-col{ padding:10px 12px; border-right:1px solid #ebeef5; }
.s-col:last-child{ border-right:0; }

/* 两列结构：标准列横跨两列 */
.s-row--merge .s-merge{ grid-column:2 / 4; border-right:0; }
.item-blank{ border-right:1px solid #ebeef5; }

/* 黄底意见 */
.s-comment{
  display:flex; gap:8px; align-items:flex-start;
  padding:8px 12px 12px; background:#fff7e6; border-top:1px dashed #f3d19e;
}
.c-label{ width:88px; color:#606266; line-height:24px; }
.c-input{ flex:1; }

/* 红底理由 */
.reject-reason{
  display:flex; gap:8px; align-items:flex-start;
  padding:12px; background:#fff1f0; border-top:1px solid #ebeef5;
}
.r-label{ width:140px; color:#ff4d4f; line-height:24px; }
.r-input{ flex:1; }
.standard {
    text-align: left;
    padding-left: 0px;
    padding-right: 0px;
}
.sdesc {
    padding-left:12px;
    padding-bottom: 12px;
}
.sbaseline {
    border-top:1px solid #ebeef5;
}
.standarddesc {
    padding-left: 12px;
}
.titlecenter {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
